@if (inputData) {
  @switch (inputData.propertyConfig.inputType) {
    @case (inputTypes.STRING) {
      <div
        class="dynamic-input-wrap"
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        >
        <label for="stringValue">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <input
          class="input dynamic-input"
          [ngClass]="{'input-default': isDefaultValue()}"
          type="text"
          fullWidth
          nbInput
          fieldSize="small"
          [disabled]="inputData.propertyConfig.disabled"
          [ngModel]="value"
          (ngModelChange)="updateValue($event, inputData.propertyConfig)"
          placeholder="{{inputData.propertyConfig.placeholder ? ('PROPERTIES.' + inputData.propertyConfig.placeholder | translate) : ('PROPERTIES.' + inputData.propertyConfig.key | translate)}}"
          name="stringValue" />
      </div>
    }
    @case (inputTypes.BOOLEAN) {
      <div
        class="dynamic-input-wrap text-left"
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        >
        <label for="{{handleInputName('booleanValue')}}">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <nb-radio-group
          [name]="handleInputName('booleanValue')"
          [ngClass]="{'input-default': isDefaultValue()}"
          [ngModel]="value"
          [disabled]="inputData.propertyConfig.disabled"
          (ngModelChange)="updateValue($event, inputData.propertyConfig)">
          <nb-radio [value]="true">{{ 'DYNAMIC_FORMS.INPUTS.RADIO.YES' | translate }}</nb-radio>
          <nb-radio [value]="false">{{ 'DYNAMIC_FORMS.INPUTS.RADIO.NO' | translate }}</nb-radio>
        </nb-radio-group>
      </div>
    }
    @case (inputTypes.DATE) {
      <div
        class="dynamic-input-wrap position-relative"
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        >
        <label for="stringValue">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <input
          [ngClass]="{'input-default': isDefaultValue()}"
          [id]="dateInputIdLabel + inputId"
          type="text"
          class="input dynamic-input cursor-pointer"
          placeholder="{{'PROPERTIES.' + inputData.propertyConfig.key | translate}}"
          fullWidth
          nbInput
          fieldSize="small"
          [ngModel]="value"
          (ngModelChange)="chosenDateHandler($event, dateInputIdLabel + inputId)"
          [max]="maxDate"
          [owlDateTimeTrigger]="dynamicFormsDateTime"
          [owlDateTime]="dynamicFormsDateTime"
          (keyup.enter)="sendDataOnEnter.emit()">
        <owl-date-time
          [pickerType]="'calendar'"
          [panelClass]="inputData.propertyConfig.settings.dateView === 'multi-years' ? 'hide-years-controls' : ''"
          [startView]="inputData.propertyConfig.settings.dateView"
          (afterPickerOpen)="afterDatePickerOpenHandler()"
          (yearSelected)="chosenYearHandler($event, dynamicFormsDateTime, dateInputIdLabel + inputId)"
          #dynamicFormsDateTime>
        </owl-date-time>
        <nb-icon class="custom-icon-datepicker" icon="calendar"></nb-icon>
      </div>
    }
    @case (inputTypes.SELECT_SEARCH_DATA_LIST) {
      <div class="dynamic-input-wrap"
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        >
        <label for="select-data-list" class="w-100">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <ingsv-adm-dropdown-search
          [inputLabel]="('PROPERTIES.' + inputData.propertyConfig.key | translate)"
          [selectedValue]="value"
          [options]="getSearchSelectOptions()"
        (selectionChange)="updateValue($event, inputData.propertyConfig)"></ingsv-adm-dropdown-search>
      </div>
    }
    @case (inputTypes.SELECT_DATA_LIST) {
      <div class="dynamic-input-wrap"
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        >
        <label for="select-data-list" class="w-100">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        @if (value && !isValueExistInOptions(value)) {
          <div class="previous-company-value mb-1"
            >
            {{'PROPERTIES_FORM.PREVIOUS_COMPANY_VALUE' | translate: { VALUE: profileService.getPropertyValue(value) } }}
          </div>
        }
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        @if (inputData.propertyConfig.showOfvManualTable) {
          <nb-toggle
            class="toggle-extra-small licenceNumberToggle"
            [ngModel]="forceUseCarRegisterData"
            (ngModelChange)="forceUseCarRegisterData = $event; useCarRegisterDataChanged.emit($event)"
            [ngModelOptions]="{standalone: true}"
            status="info"
            size="small">
            <span class="font-size--small">{{ 'OFV_TOGGLE.VARIANTS' | translate }}</span>
          </nb-toggle>
          <div class="font-size--small">
            {{ 'OFV_TOGGLE.DESCRIPTION' | translate }}
          </div>
        }
        <nb-select
          [ngClass]="{'input-default': isDefaultValue()}"
          size="small"
          class="input dynamic-input select-data-list"
          (click)="handleSelectClass()"
          placeholder="{{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}"
      [ngClass]="{
        'dynamic-input--medium-width': inputData.propertyConfig.selectWidth && inputData.propertyConfig.selectWidth === 'medium'
      }"
          [disabled]="!inputData.propertyConfig.settings?.list?.length"
          [ngModel]="value"
          (ngModelChange)="updateValue($event, inputData.propertyConfig)">
          @for (listItem of inputData.propertyConfig.settings?.list; track listItem) {
            <nb-option
              class="select-data-list-option"
              [value]="listItem.value">
              {{listItem.key | translate}}
            </nb-option>
          }
        </nb-select>
      </div>
    }
    @case (inputTypes.NUMBER) {
      <div
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        class="dynamic-input-wrap">
        <label for="numberValue">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <input
          [ngClass]="{'input-default': isDefaultValue()}"
          class="input dynamic-input"
          type="number"
          fullWidth
          nbInput
          fieldSize="small"
          [ngModel]="value"
          (ngModelChange)="updateValue($event)"
          (keyup.enter)="sendDataOnEnter.emit()"
          placeholder="{{inputData.propertyConfig.placeholder ? ('PROPERTIES.' + inputData.propertyConfig.placeholder | translate) : ('PROPERTIES.' + inputData.propertyConfig.key | translate)}}"
          name="numberValue" />
      </div>
    }
    @case (inputTypes.TEL) {
      <div
        [ngClass]="{'dynamic-input-wrap-error': isErrorParameter}"
        class="dynamic-input-wrap">
        <label for="telValue">
          {{ 'PROPERTIES.' + inputData.propertyConfig.key | translate }}
          @if (isDefaultValue()) {
            <nb-icon
              class="default-value-icon text-pointer align-bottom"
              icon="alert-circle-outline"
            [nbTooltip]="'DEFAULT_PROPERTIES_TOOLTIP' | translate"></nb-icon>
          }
        </label>
        <ingsv-adm-properties-form-notification-message
          [inputData]="inputData"
        [value]="value"></ingsv-adm-properties-form-notification-message>
        <input
          [ngClass]="{'input-default': isDefaultValue()}"
          class="input dynamic-input"
          type="tel"
          fullWidth
          nbInput
          fieldSize="small"
          [ngModel]="value"
          (ngModelChange)="updateValue($event)"
          placeholder="{{inputData.propertyConfig.placeholder ? ('PROPERTIES.' + inputData.propertyConfig.placeholder | translate) : ('PROPERTIES.' + inputData.propertyConfig.key | translate)}}"
          name="telValue"
          (keyup.enter)="sendDataOnEnter.emit()" />
      </div>
    }
  }
}
